import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { loadTooltipAssets, paintTooltipCanvas } from "./ShareTooltip";

export default function ShareTooltipPreview({ element, pixelRatio = 1, style }) {
  const ref = useRef(null);
  const [assets, setAssets] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    loadTooltipAssets().then((result) => { if (!cancelled) setAssets(result); })
      .catch((failure) => { if (!cancelled) setError(failure.message); });
    return () => { cancelled = true; };
  }, []);
  useLayoutEffect(() => {
    if (!assets) return;
    paintTooltipCanvas(ref.current, element, assets, pixelRatio * Math.min(window.devicePixelRatio || 1, 3));
  }, [element, assets, pixelRatio]);
  if (error) return <span className="share-editor-tooltip-error" role="status">{error}</span>;
  return <canvas ref={ref} className="share-editor-tooltip-art" style={style} aria-hidden="true" />;
}
